import { TranslationKeys } from '~frontend-common/i18n/english/occupation.i18n';

const keys: TranslationKeys = {
  occupation: {
    choices: {
      accounting: 'Comptable',
      actuarial: 'Actuaire',
      banking: 'Bancaire',
      clscStaff: "Employé d'un CLSC",
      dentist: 'Dentiste',
      doctor: 'Docteur',
      federalGovernment: 'Gouvernement fédéral',
      hospitalStaff: "Employé d'un hôpital",
      insurance: 'Assurance',
      lawyer: 'Avocat',
      municipalGovernment: 'Gouvernement municipal',
      notary: 'Notaire',
      nurse: 'Infirmier',
      other: {
        finance: 'Autre',
        law: 'Autre',
        generic: 'Autre',
        medical: 'Autre',
        publicCivilServices: 'Autre (pompier, travailleur de la poste, etc)',
      },
      policeOfficer: 'Policier',
      provincialGovernment: 'Gouvernement provincial',
      technician: 'Technicien',
    },
    subtitle:
      "Des rabais additionnels sont disponibles pour vous! Choisissez l'option qui décrit le mieux votre travail.",
    suggestionTitle: 'Choisissez un domaine',
  },
};

export default keys;
